/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment'
import 'moment/locale/pt';
import { Box, Button, Modal, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import PromoCodeModal from "./components/PromoCodeModal"
import FixedContainer from '../../../components/Container';
import LoadingComponent from '../../../components/LoadingComponent';
import CustomizedTables from '../../../components/Table';
import { GetFetch } from '../../../services/apiBase';

const PromoCodes = ({ history }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [openNewModal, setOpenNewModal] = useState(false);
  const [promotionalCodeList, setPromotionalCodeList] = useState();
  const [tradeAgreementToEdit, setTradeAgreementToEdit] = useState({});
  const [onEdit, setOnEdit] = useState(false);
  
  const COLUMNSTABLE = [
    {
      headerName: 'Código',
      type: 'deafult',
      value: {
        first: {
          value: 'cod'
        },
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Descrição',
      type: 'default',
      value: {
        first: {
          value: 'description'
        }
      }
    },
    {
      headerName: 'Tipo',
      type: 'default',
      value: {
        first: {
          value: 'type'
        }
      }
    },
    {
      headerName: 'Taxa',
      type: 'percent',
      value: {
        first: {
          value: 'rate'
        }
      }
    },
    {
      headerName: 'Valor mínimo',
      type: 'money',
      value: {
        first: {
          value: 'amount_start'
        }
      }
    },
    {
      headerName: 'Valor máximo',
      type: 'money',
      value: {
        first: {
          value: 'amount_end'
        }
      }
    },
    {
      headerName: 'Tempo de investimento (Meses)',
      type: 'default',
      value: {
        first: {
          value: 'years'
        },
        second: {
          value: 'months'
        }
      }
    },
    {
      headerName: 'Data inicial',
      type: 'timedate',
      value: {
        first: {
          value: 'date_initial'
        }
      }
    },
    {
      headerName: 'Data final',
      type: 'timedate',
      value: {
        first: {
          value: 'date_expires'
        }
      }
    },
    {
      headerName: 'Status',
      type: 'bool',
      value: {
        first: {
          value: 'is_active'
        }
      },
      trueMessage: 'Ativado',
      falseMessage: 'Desativado',
      noData: 'Não informado'
    },
  ]

  const handleOpenEditModal = (agreement) => {
    setTradeAgreementToEdit(agreement);
    setOnEdit(true)
    setOpenNewModal(true)
  }

  const handleOpenNewModal = () => {
    setOnEdit(false)
    setOpenNewModal(true)
  }

  const handleClose = () => {
    setOpenNewModal(false);
    setOnEdit(false)
    setTradeAgreementToEdit({})
  }

  const getListPromotionalCupons = useCallback(async () => {
    setLoading(true)
    try {
      const response = await GetFetch('/financial/promotionalCupom');
      setPromotionalCodeList(response.data);
      setError(false)
    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, []);

  const handleIcon = (item) => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '50%',
          cursor: 'pointer'
        }}
        onClick={() => handleOpenEditModal(item)}
      >
        <EditIcon />
      </Box>
    )
  }

  const tableComponent = () => {
    return (
      <Box>
        {promotionalCodeList && promotionalCodeList.length > 0
          ? 
          <>
            <CustomizedTables
              data={promotionalCodeList}
              columns={COLUMNSTABLE}
              moreOptionsTitle={'Editar'}
              moreOptions={handleIcon}
            />
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              Não foram encontradas CPRFs
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar as CPRF's resgatadas
        </Typography>
      </Box>
    )
  }

  useEffect(() => {
    getListPromotionalCupons()
  }, [])

  moment.locale('pt')
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Politicas comerciais/Códigos promocionais
          </Typography>

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: 1,
            marginTop: 1,
          }}>
              
            <Box>
              <Button variant="contained" color='success' sx={{ marginRight: 2 }} onClick={handleOpenNewModal}>Novo</Button>
            </Box>
          </Box>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
            promotionalCodeList && promotionalCodeList.length === 0 ? 
              <Box sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center'
              }}>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                  No momento não existem códigos promocionais
                </Typography>
              </Box>
              :
              <>
                {tableComponent()}
              </>
          }
        </Box>
      </FixedContainer>

      <Modal
        open={openNewModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <PromoCodeModal
          onClose={handleClose}
          getList={getListPromotionalCupons}
          editPromoCode={tradeAgreementToEdit}
          onEdit={onEdit}
        />
      </Modal>
    </>
  );
}

export default PromoCodes;
